module.exports = __webpack_public_path__ + "static/img/noproduct.b60339dc.svg";